import component from './component'
import { connect } from 'react-redux'

function mapStateToProps (state, ownProps) {
  return {
    language: state.accountReducer.language,
    username: state.accountReducer.user.username
  }
}

export default connect(
  (state, ownProps) => mapStateToProps(state, ownProps),
  null
)(component)
